import { render, staticRenderFns } from "./navShop.vue?vue&type=template&id=2fbc9436&scoped=true&"
import script from "./navShop.vue?vue&type=script&lang=js&"
export * from "./navShop.vue?vue&type=script&lang=js&"
import style0 from "./navShop.vue?vue&type=style&index=0&id=2fbc9436&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc9436",
  null
  
)

export default component.exports